import React, {useState, useRef, useEffect, Fragment} from 'react';
import {Section, Explanation_text, Select, Popup, PlusButton} from '../../../components';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import PersonIcon from '@material-ui/icons/Person';
import NoteIcon from '@material-ui/icons/Note';
import AssignmentIcon from '@material-ui/icons/Assignment';
import MeetingIcon from '@material-ui/icons/Event';
import DealIcon from '@material-ui/icons/MonetizationOn';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import {connect} from 'react-redux';



function All(props){



  useEffect(()=>{
    if(props.scorecards==undefined){props.index_scorecards();}
  },[]);


  return(
    <Grid container style={{width:'100%'}}>
    <PlusButton color='primary' options={[{label:'Scorecard', icon:<AddIcon/>, action:()=>{props.history.push('/analytics/scorecards/new')}}]}/>
    {(props.scorecards==undefined)?undefined:Object.keys(props.scorecards).map(function(key){
      let s=props.scorecards[key];
      return(<Grid item lg={6} md={12} sm={12} xs={12}><Scorecard {...props} score_card={s} scorecard={s}/></Grid>)
    })}
    </Grid>
  )
}


function Scorecard(props){
  const[delete_popup, setDeletePopup]=useState(false);

  function getIcon(type){
    if(type=='PHONE_CALLS_OUTGOING'){return(<PhoneIcon style={{color:'green'}}/>);}
    else if(type=='PHONE_CALL_ATTEMPTS'){return(<PhoneIcon style={{color:'orange'}}/>);}
    else if(type=='DEALS_OPENED'){return(<DealIcon style={{color:'green'}}/>);}
    else if(type=='OPPORTUNITIES_OPENED'){return(<DealIcon style={{color:'orange'}}/>);}
    else if(type=='EMAILS_SENT'){return(<EmailIcon color='primary'/>);}
    else if(type=='TASKS_COMPLETED'){return(<AssignmentIcon style={{color:'green'}}/>);}
    else if(type=='NEW_PROSPECTS'){return(<PersonIcon color='secondary'/>);}
    else if(type=='MEETINGS_BOOKED'){return(<MeetingIcon color='primary'/>);}
    else if(type=='day_target'){return(<TrackChangesIcon color='primary'/>)}
  }

  function getTitle(scd){
    let t=scd.quantity;
    if(scd.type=='PHONE_CALLS_OUTGOING'){t+=' phone calls connected.';}
    else if(scd.type=='PHONE_CALL_ATTEMPTS'){t+=' phone calls attempted.';}
    else if(scd.type=='DEALS_OPENED'){t+=' deals opened.';}
    else if(scd.type=='OPPORTUNITIES_OPENED'){t+=' opportunities opened.';}
    else if(scd.type=='EMAILS_SENT'){t+=' emails sent.';}
    else if(scd.type=='TASKS_COMPLETED'){t+=' tasks completed.';}
    else if(scd.type=='NEW_PROSPECTS'){t+=' new prospects.';}
    else if(scd.type=='MEETINGS_BOOKED'){t+=' meetings booked.';}
    return t+' Daily target: '+scd.target
  }

  let point_quantity=0;
  let point_target=0;
  if(props.score_card!=undefined){
    for(let st of props.score_card.scorecard_trackers){
      point_quantity+=Math.ceil((100*st.quantity)/st.target);
      point_target+=100;
    }
  }

  return(<Fragment><Section top='-40px' title={props.scorecard.name} action={<div><span><IconButton onClick={()=>{props.history.push('/analytics/scorecards/'+props.scorecard.id+'/edit');}}><EditIcon color='primary'/></IconButton></span><span><IconButton onClick={()=>{setDeletePopup(true)}}><DeleteIcon color='error'/></IconButton></span></div>}>
    <div>
    <hr style={{width:'calc(100% + 40px)', marginLeft:'-25px', marginTop:'50px'}}/>
    <Grid container style={{marginTop:'20px'}}>
    <Grid item xs={(props.score_card!=undefined && props.score_card.total_percentage==true)?10:12}>
    <Grid container>
    {(props.score_card==undefined)?<div style={{height:'50px'}}/>:props.score_card.scorecard_trackers.map(function(scd){
      return (<Tooltip title={getTitle(scd)}><Grid item xs={Math.floor(12/props.score_card.scorecard_trackers.length)} style={{display:'flex', justifyContent:'center', alignItems:'center', cursor:'pointer', height:'40px'}}><Fragment><span>{getIcon(scd.type)}</span><span style={{marginLeft:'10px', paddingBottom:'2px'}}><Typography>{Math.ceil((100*scd.quantity)/scd.target)}%</Typography></span></Fragment></Grid></Tooltip>)
    })}
    </Grid>
    </Grid>
    {(props.score_card!=undefined && props.score_card.total_percentage==true)?<Tooltip title={'Daily target'}><Grid item xs={2} style={{display:'flex', justifyContent:'center', alignItems:'center', cursor:'pointer', height:'60px', marginTop:'-10px', marginBottom:'-10px', borderWidth:'0px', borderStyle:'solid', borderLeftWidth:'1px', borderColor:'grey'}}><span>{getIcon('day_target')}</span><span style={{marginLeft:'10px', paddingBottom:'2px'}}><Typography>{(point_target==0)?0:Math.ceil((100*point_quantity)/point_target)}%</Typography></span></Grid></Tooltip>:null}
    </Grid>
    </div>
    </Section>
    {(delete_popup!=true)?null:<Delete_scorecard {...props} handleClose={()=>{setDeletePopup(false);}} deleteScorecard={()=>{props.delete_scorecard(props.scorecard.id);}}/>}
    </Fragment>)
}


function Delete_scorecard(props){
  return(
    <Popup always_open title={'Delete scorecard'} accept_button_click={()=>{props.deleteScorecard(); props.handleClose();}} handleClose={props.handleClose} content={
        <div style={{width:'600px'}}><Typography style={{width:'calc(100% - 40px)', marginLeft:'20px', textAlign:'center', marginTop:'60px', marginBottom:'60px'}}>Are you sure you want to delete this scorecard?</Typography>
    </div>} button_variant='icon_button' button={<AddIcon/>} accept_button='Remove'/>
  )
}


export default connect(ss, dd)(All);


function ss(state){
  return{
    refresh:state.analytics.refresh,
    scorecards:state.analytics.scorecards
  }
}

function dd(dispatch){
  return{
    index_scorecards:()=>{dispatch({type:'REQUEST_INDEX_SCORECARDS'})},
    delete_scorecard:(id)=>{dispatch({type:'REQUEST_DELETE_SCORECARD', id:id})}
  }
}
